"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _createStyles = _interopRequireDefault(require("../createStyles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _createStyles["default"])({
  root: {
    minWidth: function minWidth(props) {
      return props.width;
    },
    minHeight: function minHeight(props) {
      return props.height;
    }
  },
  fillInherit: {
    fill: 'currentColor'
  },
  fill: {
    fill: function fill(_ref) {
      var fillColor = _ref.fillColor;
      return fillColor || 'currentColor';
    }
  },
  stroke: {
    stroke: function stroke(_ref2) {
      var strokeColor = _ref2.strokeColor;
      return strokeColor || 'initial';
    }
  }
}, {
  name: 'Icon'
});
exports.useStyles = useStyles;
var Icon = /*#__PURE__*/(0, _react.forwardRef)(function Icon(_ref3, ref) {
  var _cn;

  var _ref3$fillColor = _ref3.fillColor,
      fillColor = _ref3$fillColor === void 0 ? '' : _ref3$fillColor,
      _ref3$strokeColor = _ref3.strokeColor,
      strokeColor = _ref3$strokeColor === void 0 ? '' : _ref3$strokeColor,
      _ref3$width = _ref3.width,
      width = _ref3$width === void 0 ? 20 : _ref3$width,
      _ref3$height = _ref3.height,
      height = _ref3$height === void 0 ? 20 : _ref3$height,
      _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? '' : _ref3$className,
      _ref3$style = _ref3.style,
      style = _ref3$style === void 0 ? {} : _ref3$style,
      jss = _ref3.jss,
      svg = _ref3.svg;
  var classes = useStyles({
    width: width,
    height: height,
    fillColor: fillColor,
    strokeColor: strokeColor,
    jss: jss
  });
  var Svg = (0, _react.useMemo)(function () {
    return svg;
  }, [svg]);
  return (
    /*#__PURE__*/
    // @ts-ignore
    _react["default"].createElement(Svg, {
      ref: ref,
      width: width,
      height: height,
      style: style,
      className: (0, _classnames["default"])(classes.root, (_cn = {}, (0, _defineProperty2["default"])(_cn, classes.fillInherit, !fillColor), (0, _defineProperty2["default"])(_cn, classes.fill, fillColor), (0, _defineProperty2["default"])(_cn, classes.stroke, strokeColor), _cn), className)
    })
  );
});
Icon.displayName = 'Icon';
var _default = Icon;
exports["default"] = _default;